export function generateUniqueName(
  name: string,
  existingNames: readonly string[],
): string {
  if (!existingNames.includes(name)) return name;

  let suffix = 2;
  while (existingNames.includes(`${name} ${suffix}`)) suffix++;
  return `${name} ${suffix}`;
}
